module.exports = __webpack_public_path__ + "media/images/common/header/shop-aea76d6fec8d6bd19f8f677b9107276b.svg";